<template>
  <v-container fluid>
    <div class="d-flex align-center mb-2">
      <div class="ml-1 font-weight-medium">บันทึกกิจกรรม (Logs)</div>
      <v-spacer></v-spacer>
      <div>
        <v-btn
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::activity-log:pdf:get')"
          depressed
          class="mr-3"
          @click="handleDownloadLogsFilePdf"
        >
          <v-icon left color="error"> mdi-file-pdf-box </v-icon>
          Pdf
        </v-btn>
        <v-btn
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::activity-log:excel:get')"
          depressed
          @click="handleDownloadLogsFileExcel"
        >
          <v-icon left color="success"> mdi-file-excel-box </v-icon>
          Excel
        </v-btn>
      </div>
    </div>
    <v-card outlined min-width="100%" class="px-3 mb-1">
      <div class="d-flex align-end flex-wrap py-2">
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่
          </div>
          <date-picker
            v-model="date"
            type="date"
            format="DD/MM/YYYY"
            :clearable="false"
            style="width: 180px"
            @change="handleDateChange"
          ></date-picker>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            เวลาเริ่ม - สิ้นสุด
          </div>
          <date-picker
            v-model="time"
            type="time"
            format="HH:mm"
            range
            :clearable="false"
            style="width: 180px"
          ></date-picker>
        </div>
        <!-- <div class="mr-2">
          <div style="color: #555;font-size: 12px;margin-left: 5px;">
            วันที่สิ้นสุด
          </div>
          <date-picker
            v-model="dateEnd"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :clearable="false"
            :disabled-date="disabledBeforeDateStart"
            :disabled-time="disabledBeforeTimeStart"
          ></date-picker>
        </div> -->
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            ข้อมูลและการดำเนินการ
          </div>
          <v-dialog
            v-model="dialogOperation"
            scrollable
            max-width="640px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-card
                v-bind="attrs"
                v-on="on"
                outlined
                width="180"
                class="d-flex justify-space-between pl-2 py-2"
              >
                <span class="grey--text text--darken-2">
                  {{
                    filterResources.length
                      ? `${filterResources.length} ข้อมูล`
                      : 'ไม่ระบุ'
                  }}
                </span>
                <v-icon right color="grey lighten-1"
                  >mdi-file-document-outline</v-icon
                >
              </v-card>
            </template>
            <v-card>
              <v-card-title>
                ข้อมูลและการดำเนินการ
                <v-spacer></v-spacer>
                <v-btn icon @click="handleCancelFilterResources">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="height: 480px" class="py-6">
                <v-row>
                  <v-col cols="12">
                    <v-expansion-panels multiple v-model="panel">
                      <v-expansion-panel
                        v-for="(statement, i) in userRole.policy.Statements"
                        :key="i"
                      >
                        <v-expansion-panel-header class="pl-2 py-1">
                          <template v-slot:default>
                            <div class="d-flex align-center">
                              <v-btn
                                :disabled="userRole.is_default"
                                icon
                                @click.stop="handleDeleteRole(statement.id)"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                              <span class="ml-2">
                                {{ statement.TitleTH || 'เลือกข้อมูล' }}
                              </span>
                            </div>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content v-if="statement.TitleTH">
                          <p class="mb-1">การอนุญาต</p>
                          <div
                            v-for="(statementAction, i) in statement.Actions"
                            :key="i"
                          >
                            <div
                              v-for="(action, i) in statementAction.Actions"
                              :key="i"
                            >
                              <v-checkbox
                                :disabled="userRole.is_default"
                                v-model="action.checked"
                                class="my-1"
                                :label="action.TitleTH"
                                hide-details
                              ></v-checkbox>
                            </div>
                          </div>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content v-else>
                          <v-btn
                            style="width: 200px"
                            outlined
                            @click="handleChooseRole(statement.id)"
                          >
                            เลือกข้อมูล
                          </v-btn>
                          <v-dialog
                            v-model="dialogAddUserRole"
                            scrollable
                            max-width="520px"
                          >
                            <v-card>
                              <v-card-text class="pa-0" style="height: 300px">
                                <div
                                  v-for="(
                                    group, i
                                  ) in policySpecification.PolicyGroups"
                                  :key="i"
                                >
                                  <h3 class="px-4 py-2 grey lighten-3">
                                    {{ group.TitleTH }}
                                  </h3>
                                  <ul class="py-2">
                                    <li
                                      v-for="(resource, i) in group.Resources"
                                      :key="i"
                                      style="
                                        list-style: none;
                                        margin: 8px 16px;
                                        cursor: pointer;
                                      "
                                      class="btn-link"
                                      @click="handleSelectedRole(resource)"
                                    >
                                      <div
                                        v-if="
                                          policySpecification.PolicySpecs[
                                            resource
                                          ]
                                        "
                                      >
                                        {{
                                          policySpecification.PolicySpecs[
                                            resource
                                          ].TitleTH
                                        }}
                                      </div>
                                    </li>
                                  </ul>
                                  <div
                                    style="
                                      padding-bottom: 16px;
                                      text-align: center;
                                      color: grey;
                                    "
                                    v-if="group.Resources.length === 0"
                                  >
                                    ข้อมูลถูกเพิ่มไปแล้ว
                                  </div>
                                  <v-divider></v-divider>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="5">
                    <v-btn outlined @click="handleAddRole">
                      <v-icon small left>mdi-plus</v-icon>เพิ่มข้อมูล
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="handleSubmitFilterResources">
                  ตกลง
                </v-btn>
                <v-btn @click="handleCancelFilterResources"> ยกเลิก </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div class="mr-2" style="width: 180px">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            filter รายละเอียด
          </div>
          <v-text-field
            v-model="filterResourceIdentifier"
            outlined
            dense
            hide-details
            height="41"
          ></v-text-field>
        </div>
        <div class="mr-4" style="width: 180px">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            filter ผู้ดำเนินการ
          </div>
          <v-text-field
            v-model="filterUserIdentifier"
            outlined
            dense
            hide-details
            height="41"
          ></v-text-field>
        </div>
        <div class="mb-1">
          <v-btn
            :disabled="loading"
            depressed
            color="primary"
            @click="handleGetDataFromApi"
            >ตกลง</v-btn
          >
        </div>
      </div>
    </v-card>

    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :loading-text="loadingText"
      :headers="headers"
      :items="activityLogs"
      :options.sync="options"
      :server-items-length="totalActivityLogs"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
        itemsPerPageText: 'Row per page:',
      }"
      must-sort
    >
      <template v-slot:item.timestamp="{ item }">
        {{ item | datetimeFormat }}
      </template>
      <template v-slot:item.resource.resource="{ item }">
        <div v-if="policySpecificationData['PolicySpecs']">
          {{
            policySpecificationData['PolicySpecs'][item.resource.resource]
              ? policySpecificationData['PolicySpecs'][item.resource.resource]
                  .TitleTH
              : ''
          }}
        </div>
      </template>
      <template v-slot:item.resource.action="{ item }">
        {{ getAction(item.resource.resource, item.resource.action) }}
      </template>
      <template v-slot:item.user="{ item }">
        <span v-if="item.user.employee">
          {{ item.user.employee.identifier }}
        </span>
        <span v-else-if="item.user.admin">
          {{ item.user.admin.identifier }}
        </span>
        <span v-else-if="item.user.session_user">
          {{ item.user.session_user.identifier }}
        </span>
        <span v-else-if="item.user.support">
          {{ item.user.support.identifier }}
        </span>
      </template>
      <template v-slot:item.type_user="{ item }">
        <span v-if="item.user.employee"> Employee </span>
        <span v-else-if="item.user.admin"> Admin </span>
        <span v-else-if="item.user.session_user"> Session User </span>
        <span v-else-if="item.user.support"> Support </span>
      </template>
      <template v-slot:item.resource_detail="{ item }">
        {{ item.resource.identifier.key }}: {{ item.resource.identifier.value }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      filterResourceIdentifier: '',
      filterUserIdentifier: '',
      dialogOperation: false,
      dateStart: '',
      dateEnd: '',
      date: new Date(),
      time: [
        new Date(new Date().setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(23, 59, 0, 0)),
      ],
      sortBy: ['timestamp'],
      sortDesc: [true],
      loading: false,
      loadingText: 'Loading... Please wait',
      options: {},
      headers: [
        {
          text: 'เวลา',
          align: 'start',
          value: 'timestamp',
          width: '165',
        },
        {
          text: 'IP Address',
          value: 'ip',
          width: '140',
        },
        {
          text: 'ข้อมูล',
          value: 'resource.resource',
          sortable: false,
          width: '150',
        },
        {
          text: 'การดำเนินการ',
          value: 'resource.action',
          sortable: false,
          width: '190',
        },
        {
          text: 'รายละเอียด',
          sortable: false,
          value: 'resource_detail',
          sortable: false,
        },
        {
          text: 'ผู้ดำเนินการ',
          value: 'user',
          sortable: false,
          width: '100',
        },
        {
          text: 'ประเภทผู้ดำเนินการ',
          value: 'type_user',
          sortable: false,
          width: '130',
        },
      ],
      dialogAddUserRole: false,
      panel: [],
      statementId: '',
      userRole: {
        policy: {
          Statements: [],
        },
      },
      userRoleInit: {
        policy: {
          Statements: [],
        },
      },
      filterResources: [],
      dialogProgress: false,
      progressValue: 0,
      interval: null,
      timeout: null,
    }
  },
  filters: {
    datetimeFormat: function (item) {
      return moment(item.timestamp).format('DD/MM/YYYY HH:mm:ss')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    activityLogs() {
      return this.$store.state.activityLog.activityLogs
    },
    totalActivityLogs() {
      return this.$store.state.activityLog.totalActivityLogs
    },
    policySpecificationData() {
      return this.$store.state.userRole.policySpecification
    },
    policySpecification() {
      return {
        PolicyGroups:
          this.$store.state.userRole.policySpecification.PolicyGroups.map(
            (group) => {
              return {
                ...group,
                Resources: group.Resources.filter((resource) => {
                  return !this.userRole.policy.Statements.some(
                    (statement) => statement.Resource === resource
                  )
                }),
              }
            }
          ),
        PolicySpecs: this.$store.state.userRole.policySpecification.PolicySpecs,
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'บันทึกกิจกรรม (Logs)',
        disabled: true,
      },
    ])

    try {
      this.$store.state.loading = true

      await this.fetchPolicySpecification()
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      getActivityLogs: 'activityLog/getActivityLogs',
      fetchPolicySpecification: 'userRole/fetchPolicySpecification',
      generateLogsFileExcel: 'download/generateLogsFileExcel',
      generateLogsFilePdf: 'download/generateLogsFilePdf',
      generateFileProgress: 'download/generateFileProgress',
    }),
    handleDateChange() {
      this.time = [
        new Date(new Date().setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(23, 59, 0, 0)),
      ]
    },
    handleCancelFilterResources() {
      this.userRole = JSON.parse(JSON.stringify(this.userRoleInit))
      this.dialogOperation = false
    },
    handleDeleteRole(statementId) {
      this.userRole.policy.Statements = this.userRole.policy.Statements.filter(
        (statement) => statement.id !== statementId
      )
    },
    handleSubmitFilterResources() {
      this.filterResources = this.userRole.policy.Statements.map(
        (statement) => {
          if (statement.Actions) {
            return {
              resource: statement.Resource,
              actions: this.getActions(statement.Actions),
            }
          }
        }
      ).filter((statement) => statement !== undefined)

      if (this.filterResources.length) {
        this.userRoleInit = JSON.parse(JSON.stringify(this.userRole))
      } else {
        this.userRole = {
          policy: {
            Statements: [],
          },
        }
        this.userRoleInit = {
          policy: {
            Statements: [],
          },
        }
      }

      this.dialogOperation = false
    },
    getActions(items) {
      const actions = []
      items?.forEach((action) => {
        action.Actions.forEach((action) => {
          if (action.checked) {
            actions.push(action.Action)
          }
        })
      })
      return actions
    },
    handleSelectedRole(resource) {
      this.userRole.policy.Statements = this.userRole.policy.Statements.map(
        (statement) => {
          if (statement.id === this.statementId) {
            return {
              ...statement,
              Resource: resource,
              TitleTH: this.policySpecification.PolicySpecs[resource].TitleTH,
              Actions: this.policySpecification.PolicySpecs[
                resource
              ].ActionPropertiesRequired.map((action) => {
                return {
                  ...action,
                  Actions: action.Actions.map((action) => {
                    return {
                      ...action,
                      checked: true,
                    }
                  }),
                }
              }),
            }
          }

          return statement
        }
      )
      this.dialogAddUserRole = false
    },
    handleChooseRole(statementId) {
      this.dialogAddUserRole = true
      this.statementId = statementId
    },
    handleAddRole() {
      this.userRole.policy.Statements.push({
        id: uuidv4(),
      })
    },
    getAction(resource, resourceAction) {
      let result = ''
      const actionPropertiesRequired = this.policySpecificationData.PolicySpecs[
        resource
      ]
        ? this.policySpecificationData.PolicySpecs[resource]
            .ActionPropertiesRequired
        : null

      if (actionPropertiesRequired) {
        actionPropertiesRequired.forEach((action) => {
          action.Actions.forEach((act) => {
            if (act.Action === resourceAction) {
              result = act.TitleTH
            }
          })
        })
      }
      return result
    },
    disabledAfterTimeEnd(date) {
      if (!this.dateEnd) return false
      return moment(date).format('HH:mm') > moment(this.dateEnd).format('HH:mm')
    },
    disabledBeforeTimeStart(date) {
      if (!this.dateStart) return false
      return (
        moment(date).format('HH:mm') < moment(this.dateStart).format('HH:mm')
      )
    },
    disabledAfterDateEnd(date) {
      if (!this.dateEnd) return false
      return (
        moment(date).format('DD/MM/YYYY') >
        moment(this.dateEnd).format('DD/MM/YYYY')
      )
    },
    disabledBeforeDateStart(date) {
      if (!this.dateStart) return false
      return (
        moment(date).format('DD/MM/YYYY') <
        moment(this.dateStart).format('DD/MM/YYYY')
      )
    },
    handleGetDataFromApi() {
      this.getDataFromApi()
    },
    getDataFromApi() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          skip: (page - 1) * itemsPerPage,
          limit: itemsPerPage,
          sort: {
            field: sortBy[0] || null,
            order: sortDesc[0] ? 'desc' : 'asc',
          },
          filters: {
            user_identifier: this.filterUserIdentifier
              ? this.filterUserIdentifier
              : null,
            resource_identifier: this.filterResourceIdentifier
              ? this.filterResourceIdentifier
              : null,
            time: {
              time_start: this.date
                ? moment(this.date)
                    .set('hour', this.time[0].getHours())
                    .set('minute', this.time[0].getMinutes())
                    .set('second', 0)
                    .format()
                : null,
              time_end: this.date
                ? moment(this.date)
                    .set('hour', this.time[1].getHours())
                    .set('minute', this.time[1].getMinutes())
                    .set('second', 59)
                    .format()
                : null,
            },
            // time: {
            //   time_start: this.dateStart
            //     ? moment(this.dateStart).format()
            //     : null,
            //   time_end: this.dateEnd
            //     ? moment(this.dateEnd)
            //         .seconds('59')
            //         .format()
            //     : null
            // },
            resources: this.filterResources.length
              ? this.filterResources
              : null,
          },
        },
      }
      this.loading = true

      this.getActivityLogs(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    handleDownloadLogsFilePdf() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          sort: {
            field: sortBy[0] || null,
            order: sortDesc[0] ? 'desc' : 'asc',
          },
          filters: {
            user_identifier: this.filterUserIdentifier
              ? this.filterUserIdentifier
              : null,
            resource_identifier: this.filterResourceIdentifier
              ? this.filterResourceIdentifier
              : null,
            time: {
              time_start: this.date
                ? moment(this.date)
                    .set('hour', this.time[0].getHours())
                    .set('minute', this.time[0].getMinutes())
                    .set('second', 0)
                    .format()
                : null,
              time_end: this.date
                ? moment(this.date)
                    .set('hour', this.time[1].getHours())
                    .set('minute', this.time[1].getMinutes())
                    .set('second', 59)
                    .format()
                : null,
            },
            resources: this.filterResources.length
              ? this.filterResources
              : null,
          },
          timezone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
          is_locale_en: false,
        },
      }

      this.generateLogsFilePdf(payload)
        .then((res) => {
          if (!this.activityLogs.length) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'ไม่มีข้อมูล',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }

          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    handleDownloadLogsFileExcel() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          sort: {
            field: sortBy[0] || null,
            order: sortDesc[0] ? 'desc' : 'asc',
          },
          filters: {
            user_identifier: this.filterUserIdentifier
              ? this.filterUserIdentifier
              : null,
            resource_identifier: this.filterResourceIdentifier
              ? this.filterResourceIdentifier
              : null,
            time: {
              time_start: this.date
                ? moment(this.date)
                    .set('hour', this.time[0].getHours())
                    .set('minute', this.time[0].getMinutes())
                    .set('second', 0)
                    .format()
                : null,
              time_end: this.date
                ? moment(this.date)
                    .set('hour', this.time[1].getHours())
                    .set('minute', this.time[1].getMinutes())
                    .set('second', 59)
                    .format()
                : null,
            },
            resources: this.filterResources.length
              ? this.filterResources
              : null,
          },
          timezone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
          is_locale_en: false,
        },
      }

      this.generateLogsFileExcel(payload)
        .then((res) => {
          if (!this.activityLogs.length) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'ไม่มีข้อมูล',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }

          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    downloadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              const fileUrl = res.resource_uri
              const fileName = fileUrl.split('/').pop()

              const a = document.createElement('a')
              a.setAttribute('hidden', '')
              a.setAttribute('href', fileUrl)
              a.setAttribute('target', '_blank')
              a.setAttribute('download', fileName)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)

              clearInterval(this.interval)
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
  },
}
</script>
